module.exports = __webpack_public_path__ + "media/images/admin/dashboard-posts-855857f34ada1328dba406de6da8ae90.jpg";